import { render, staticRenderFns } from "./details-section.vue?vue&type=template&id=2172e640&scoped=true&"
import script from "./details-section.vue?vue&type=script&lang=js&"
export * from "./details-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172e640",
  null
  
)

export default component.exports